(function(){

'use strict';

function pxPrinterStatusList() {
  return {
    restrict: 'EA',
    scope: {
      printer: '=printer',
      callback: '&callback'
    },
    templateUrl: 'app/directives/printerStatusListDirective/printer-status-list.template.html',
    link: function(scope) {

      scope.openPrinterStatus = function($event) {
        scope.callback({event: $event, printer: scope.printer});
      }
      
    }
  }
}

pxPrinterStatusList.$inject = [];

angular
  .module('printix-admin')
  .directive('pxPrinterStatusList', pxPrinterStatusList);

})();